import { winnercup } from 'src/assets/images';
import cx from './toppersection.module.scss';
import { TVenture } from 'src/services/apiEndpoint.types.ts/ventures/ventures.types';
import ImageCard from 'src/components/demodaycard/image-card/ImageCard';
import { textFormatter } from 'src/utils';
import { useGetIdentity } from 'src/hooks';
import { useNavigate } from 'react-router-dom';

export default function TopperSection({ ventures }: { ventures: TVenture[] }) {
    const navigate = useNavigate();
    const { getIdentities } = useGetIdentity();
    const { authenticatedId } = getIdentities();
    function handleNavigate(item: TVenture) {
        if (authenticatedId && (item?.userId === authenticatedId || item?.companyId === authenticatedId)) {
            navigate(`/my-venture?id=${item?.id}`);
        } else {
            navigate(`/view-venture?id=${item?.id}`);
        }
    }
    return (
        <section className={cx.section}>
            <div className={cx.container}>
                <header className={cx.header}>
                    <img src={winnercup} alt="winner" />
                    <h2>Top Ventures of Our Demo Day</h2>
                </header>

                <div className={cx.venturesGrid}>
                    {ventures.map((venture: TVenture) => {
                        const title = venture?.title?.slice(0, 15);
                        const isEllipsedTitle = title?.length < venture?.title?.length;
                        const founder = venture?.User?.name || venture?.Company?.name || '';
                        const dynamicFounder = founder?.slice(0, 15)
                        const isEllipsedFounder = dynamicFounder?.length < founder?.length;
                        return (
                            <div key={venture.id} className={cx.ventureCard} onClick={() => handleNavigate(venture)}>
                                <div className={cx.ventureImage}>
                                    <ImageCard
                                        url={venture?.logo || ''}
                                        height={"110px"}
                                        width={"110px"}
                                        fallbackStyle={{
                                            fontSize: '30px'
                                        }}
                                        fallbackColor='#fff'
                                        background="#D9D9D9"
                                        fallback={textFormatter({ value: venture?.title?.[0] })}
                                    />
                                </div>
                                <div className={cx.ventureInfo}>
                                    <h3 className={cx.ventureName} title={venture?.title}>{title + `${isEllipsedTitle ? '...' : ''}`}</h3>
                                    <p className={cx.founderName} title={founder}>{dynamicFounder + `${isEllipsedFounder ? '...' : ''}`}</p>
                                </div>
                            </div>
                        )
                    }
                    )}
                </div>
            </div>
        </section>
    );
}
